import React from 'react';
import { createPortal } from 'react-dom';
import { useMobileDrawerStyles } from 'components/UI/V2/MobileDrawer/MobileDrawer.styles';
import { ClickAwayListener } from '@material-ui/core';
import clsx from 'clsx';

interface MobileDrawerProps extends React.PropsWithChildren {
    className?: string;
    onClose?: () => void;
}

export const MobileDrawer: React.FC<MobileDrawerProps> = props => {
    const classes = useMobileDrawerStyles();

    return createPortal(
        <>
            <div className={classes.backdrop}></div>

            <ClickAwayListener onClickAway={() => props.onClose?.()}>
                <div className={clsx(classes.root, props.className)}>
                    <div className={classes.chip}></div>

                    {props.children}
                </div>
            </ClickAwayListener>
        </>,
        document.body
    );
};
